<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <div class="trinka_cloud_banner_text">
                        <h1>Assistência para Redação em seu Aplicativo</h1>
                        <p>Trinka AI permite que você adicione suporte de escrita em tempo real diretamente ao seu aplicativo
                            com facilidade. Crie soluções exclusivas, oferecendo sugestões de redação precisas de Trinka
                            de várias maneiras para seus usuários.
                        </p>
                        <button data-toggle="modal"
                            data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">Obtenha uma Cotação</button>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/technologyPlatform.png" alt="Trinka enterprise" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="most_suited_for_section">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="most_united_heading">
                        <h2>
                            <span></span>Integrações Exclusivas para Alimentar Aplicativos Adequados</h2>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="most_suited_point">
                        <ul>
                            <li>Sistemas de gerenciamento de conteúdo</li>
                            <li>Plataformas de redação online</li>
                            <li>Software CRM + Helpdesk</li>
                            <li>Email de clientes</li>
                            <li>Software de gerenciamento de projetos </li>
                            <li>Plataformas de e-learning</li>
                            <li>Sistemas de Gestão de Aprendizagem</li>
                            <li>Aplicativos de mensagens / Plataformas Sociais</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="wayToIntegrateTrinka">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="integreate_heading_section">
                        <h2>Recursos Exclusivos para Potencializar Experiências Exclusivas em seus Produtos</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Melhore o seu produto e a experiência do cliente com acesso ilimitado a todos os recursos poderosos
                            de Trinka. De correções gramaticais avançadas de inglês a melhorias no tom e no estilo, Trinka
                            oferece assistência abrangente na escrita.</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <ul>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/Real-timewritingsuggestions.png" alt="Real time Writing Suggestions" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Assistência avançada de escrita em tempo real nos aplicativos</h3>
                                    <p>Trinka AI verifica erros gramaticais complexos em tempo real, diretamente no seu aplicativo.
                                        Além de verificações gramaticais, Trinka melhora a redação para vocabulário, tom,
                                        sintaxe, fraseado e muito mais.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/Qualityassessment.png" alt="Quality Assesment" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Pontuação personalizada e dicionários pessoais</h3>
                                    <p>Pontue a escrita do seu usuário com algoritmos de pontuação personalizáveis e deixe-os
                                        personalizar a sua assistência de redação com dicionários específicos do usuário.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/WhiteLabel.png" alt="White Label" srcset="White Label">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Etiqueta branca</h3>
                                    <p>Com a etiqueta branca completa, Trinka se integrará perfeitamente ao seu produto. Continue
                                        aproveitando o poder e a confiança de sua marca usando nossas soluções personalizadas
                                        com etiqueta branca.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/DedicatedSupport.svg" alt="Dedicated Support" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Suporte Dedicado</h3>
                                    <p>Um Gerente de Sucesso dedicado é designado para apoiar a sua equipe para obter o máximo
                                        de Trinka. Isso inclui uma chamada de integração minuciosa, documentação de ajuda
                                        e orientações em vídeo.
                                    </p>
                                </div>
                            </div>
                        </li>

                    </ul>
                    <!-- <span class="bottom_diviedLine"></span> -->
                    <!-- <span class="bottom_diviedLine1"></span> -->

                </div>
            </div>

        </div>
    </div>
</div>

<div class="advanceGrammerSpellCheck_section backgrondSecitons_outer accomplishSections sec2">
    <div class="container">
        <div class="row">
            <div class="col-xl-4">
                <div class="spellcheck_heading EnhancementsHeadingSection">
                    <h2>Integrações Flexíveis para Cada Caso de uso </h2>
                    <div class="HeadingSubLine"></div>
                    <p>Use os vários recursos de Trinka para criar recursos que impulsionam o crescimento</p>
                </div>
            </div>
            <div class="col-xl-8">
                <div class="all_usecases">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>Assistência em Tempo Real</h4>
                                <p>Permite que os seus usuários obtenham feedback por escrito instantaneamente no conforto de
                                    seu aplicativo.</p>
                                <ul>
                                    <li>Mais de 3.000 verificações gramaticais </li>
                                    <li>Explicações detalhadas</li>
                                    <li>Correções personalizadas</li>

                                </ul>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>Avaliação da Qualidade da Escrita</h4>
                                <p>Trinka AI fornece pontuações de qualidade personalizáveis e análises de erros que podem potencializar
                                    experiências de aprendizagem adequadas a sistemas de gerenciamento de aprendizagem (SGA),
                                    aplicativos de e-Learning e muito mais.
                                </p>
                                <ul>
                                    <li>Escrevendo pontuações de qualidade</li>
                                    <li>Relatório de erro de escrita categorizado</li>
                                    <li>Correções interativas com explicações</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="all_usecases_item all_usecases_item_last">
                                <h4>Personalização de Prateleira </h4>
                                <p>Trinka permite que você ofereça experiências personalizadas com suporte para dicionários
                                    do usuário, correções personalizáveis e guias de estilo e painéis personalizados.</p>
                                <ul>
                                    <li>Permite que os usuários criem seus dicionários pessoais</li>
                                    <li>Adiciona guias de estilo personalizados relevantes para sua marca / aplicativo</li>
                                    <li>Obtem insights precisos com poderosa coleta e monitoramento de dados</li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


        </div>
    </div>
</div>
<div class="softWare_workFlow cloud_key_features">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="brandlogo_heading key_features_heading">
                    <h2>Integre com seu Software Proprietário e Fluxos de Trabalho</h2>
                </div>
                <div class="HeadingSubLine"></div>
                <p>As integrações fáceis de Trinka permitem que suas equipes desfrutem de todos os benefícios diretamente no
                    software existente, tornando a escrita eficaz, produtiva e contínua.</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>JavaScript</h3>

                    <p>
                        Habilite Trinka para todos os membros de sua equipe simplesmente inserindo um pequeno trecho de código JavaScript (JS) em
                        seu navegador ou qualquer aplicativo.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">
                    <h3>API</h3>
                    <p>
                        O poderoso verificador Trinka API traz Trinka direto para seus aplicativos existentes. Com uma arquitetura de API simples,
                        é fácil de integrar.</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>Na Premissa</h3>
                    <p>Garanta uma redação eficaz e máxima confidencialidade com Trinka hospedado em sua infraestrutura corporativa,
                        seja em servidores locais ou em nuvem.
                    </p>

                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>Cloud Editor</h3>


                    <p>
                        Use todo o potencial de Trinka em qualquer lugar, com o aplicativo seguro baseado na web.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>Suplemento MS Word</h3>
                    <p>
                        Aumente a produtividade de suas equipes com sugestões de redação fornecidas no MS Word.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">
                    <h3>Plug-ins no Navegador</h3>
                    <p>
                        Assistência de redação em tempo real em qualquer site da Web por meio de plug-ins para todos os seus navegadores favoritos.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="most_suited_for_section pricing_works">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="brandlogo_heading">
                    <h2>Preços Personalizados que Funcionam para Você</h2>
                </div>
                <p>Trinka oferece preços flexíveis para usuário ou baseados no uso para atender às suas necessidades exclusivas.
                    <br>Troque de usuário e aplique restrições de uso em tempo real, sem nenhum custo extra.
                    <br>Trabalharemos com você para criar um contrato personalizado sem complicações e uma opção de pagamento
                    único por meio de pedido de compra / fatura. </p>
            </div>

            <div class="col-lg-12">
                <div class="try_trinka_Buttons">
                    <!-- <a href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank">Get a Quote</a> -->

                    <button data-toggle="modal"
                        data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">Obtenha uma cotação</button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="writeToolboxs_section">
    <div class="writeToolbox_inner_sections">
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>Seguro e confiável</h3>
                        <p>Trinka coloca a segurança e a privacidade dos dados em primeiro plano. Todos os seus dados são fortemente
                            criptografados e armazenados com segurança - ninguém mais tem acesso aos seus dados. Oferecemos
                            planos exclusivos que eliminam completamente o salvamento de qualquer dado assim que você receber
                            sugestões de redação.
                        </p>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="../../../assets/images/safe-secure.png" alt="Safe Secure" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolbox_inner_sections sections_height_set publicationCheckSections" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');">
        <div class="container">
            <div class="row">
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="../../../assets/images/about-ai.png" alt="About AI" class="img-fluid">
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>Sobre a AI</h3>
                        <p>Trinka usa as mais recentes técnicas de aprendizado de máquina (ML) e processamento de linguagem
                            natural (PNL) para identificar erros gramaticais e sugerir aprimoramentos de linguagem. Ele é
                            treinado em milhões de documentos e artigos bem escritos que abrangem mais de 1300 áreas, incluindo
                            medicina, ciências biológicas, biologia , ciências físicas, engenharia, humanas, negócios e artes
                            para dar a você as sugestões mais relevantes.</p>
                        <p>Trinka é desenvolvido por uma equipe de lingüistas, editores médicos, cientistas de dados e engenheiros
                            com um profundo desejo de criar um futuro com comunicação sem barreiras.
                        </p>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="enterprise_contactUs">
    <p>Permita que seus usuários escrevam melhor</p>
    <button data-toggle="modal" data-target="#EnterPriseContactPopup"
        class="plansButtons" type="submit">Obtenha uma Cotação</button>
</div>


<app-enterprise-modal></app-enterprise-modal>